import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { SiteConfigurationTemplate, TagMapping } from '../../../types';
import { StatusChip } from '../StatusChip';
import { EmptySection } from '../EmptySection';
import { useTagMappingStatus } from 'src/features/sites/hooks';

type AlarmRulesSectionProps = {
  template: SiteConfigurationTemplate;
  tagMapping: TagMapping;
};

export const AlarmRulesSection = ({ template, tagMapping }: AlarmRulesSectionProps) => {
  const { isBlockingUnmapped, unmappedNames } = useTagMappingStatus(template, tagMapping);

  const rows = template.alarmRules;
  if (!rows.length) return <EmptySection label="Alarm Rules" />;

  return (
    <TableContainer>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Rule Name</TableCell>
            <TableCell>Priority</TableCell>
            <TableCell>Conditions</TableCell>
            <TableCell>Note</TableCell>
            <TableCell align="right">Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((rule) => {
            const conditionTagIds = (rule.conditions ?? []).map((c) => c.tagIdempotencyKey);
            const included = conditionTagIds.every((id) => !isBlockingUnmapped(id));
            const missing = unmappedNames(conditionTagIds);

            return (
              <TableRow key={rule.id}>
                <TableCell>{rule.title || '—'}</TableCell>
                <TableCell>{rule.priority || '—'}</TableCell>
                <TableCell>
                  <Typography variant="caption" color="text.secondary">
                    {(rule.conditions ?? []).length} condition
                    {(rule.conditions ?? []).length !== 1 ? 's' : ''}
                  </Typography>
                </TableCell>
                <TableCell>
                  {!included && missing.length ? (
                    <Typography variant="caption" color="warning.main">
                      Unmapped: {missing.join(', ')}
                    </Typography>
                  ) : null}
                </TableCell>
                <TableCell align="right">
                  <StatusChip included={included} />
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
